import { type ButtonHTMLAttributes, type FC, type ReactNode } from 'react'

import { buttonClassName, type ButtonSize, type ButtonVariant } from './buttonClassName'

import './index.scss'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  isActive?: boolean // For icon buttons to show active state
  children: ReactNode
}

export const Button: FC<ButtonProps> = ({
  variant,
  size,
  isActive,
  className,
  children,
  type = 'button',
  ...props
}) => (
  <button type={type} className={buttonClassName({ variant, size, isActive, className })} {...props}>
    {children}
  </button>
)
